interface ErrorAlertProps {
  message: string;
  /** Short label displayed in bold before the message. Defaults to "Error". */
  label?: string;
}

/** Red alert card for surfacing error messages to the user. */
export function ErrorAlert({ message, label = 'Error' }: ErrorAlertProps) {
  return (
    <div className="bg-red-50 border border-red-200 rounded-xl p-4 mb-6 text-sm text-red-700">
      <strong>{label}:</strong> {message}
    </div>
  );
}
